module.exports = __webpack_public_path__ + "static/media/hero-image-desktop@3x.6424190d.jpg";